/**
 *
 * @module thumbnailPresentationType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ThumbnailPresentationType
 * @type {Object}
 * @desc specifies the type of Thumbnail you are using
 * @example ThumbnailPresentationType.BUMPER // 'BUMPER'
 *
 * @property {String} BUMPER
 * @property {String} MAIN
 * @property {String} DUB_CARD
 *
 */

/**
 *
 * @enum
 * @type {ThumbnailPresentationType}
 *
 */
export default KeyMirror({
    /**
     *
     * @type {String}
     *
     */
    BUMPER: null,
    /**
     *
     * @type {String}
     *
     */
    MAIN: null,
    /**
     *
     * @type {String}
     *
     */
    DUB_CARD: null
});



// WEBPACK FOOTER //
// ./src/services/media/thumbnailPresentationType.js